import React, { FC } from 'react';
import { SettingsFormPageSkeleton } from '../settings/settingsSkeleton';

export const EcommerceStartPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
